export const latitude: number = 47.96001;
export const longitude: number = 7.83090;